module.exports = __webpack_public_path__ + "img/NoPath2@2x.35367b25.png";